/* eslint-disable camelcase */
import { localUrlEnum } from "./UrlEnum";
import { Vocabulary } from "./Vocabulary";

///
export const internalLocationArray = ["CUSTOMER", "IN TRANSIT", "IN SERVICE"];

///
export const notesVisibility = {
  hidden: "HIDDEN",
  visible: "VISIBLE",
  deleted: "DELETED",
};

///
export const notesVisibilityArray = [
  {
    label: "Internal",
    name: "HIDDEN",
  },
  { label: "Public", name: "VISIBLE" },
  { label: "Removed", name: "DELETED" },
];

///
export const notesType = {
  auftragAngelegt: "Auftrag angelegt",
  auftragFehlerbeschreib: "Descrierea comenzii / erorii",
  issue: "ISSUE",
  diagnosis: "DIAGNOSIS",
  resolution: "RESOLUTION",
  internal: "INTERNAL",
  email: "EMAIL",
  sms: "SMS",
  detail: "DETAIL",
  other: "OTHER",
};

///
export const notesTypeArray = [
  "Auftrag angelegt",
  "Descrierea comenzii / erorii",
  "ISSUE",
  "DIAGNOSIS",
  "RESOLUTION",
  "INTERNAL",
  "EMAIL",
  "SMS",
  "DETAIL",
  "OTHER",
];

///
export const defaultNote_OrderCreated = {
  _id: null,
  type: notesType.auftragAngelegt,
  title: "Descrierea comenzii / erorii",
  text: "",
  status: 0,
  visibility: notesVisibility.hidden,
  report: 0,
  createdBy: null,
  createdAt: new Date(),
};

///
export const FilesTypes = {
  pdf: "application/pdf",
  png: "image/png",
  jpeg: "image/jpeg",
  jpg: "image/jpg",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

///
export const stepTypes = {
  password: "password",
  boolean: "boolean",
  text: "text",
  multiselect: "multiselect",
};

///
export const booleanTypes = {
  yes: "yes",
  no: "no",
};

///
export const booleanTypesArray = [
  {
    text: "yes",
  },
  {
    text: "no",
  },
];

///
export const usersTypes = {
  employees: "employees",
  customers: "customers",
  vendors: "vendors",
  partners: "partners",
};

export const costsTypes = {
  manual: "manual",
  automatic: "automatic",
};

///
export const stocksManagementTypes = {
  inventories: "inventories",
  transfers: "transfers",
  incomingGoods: "incomingGoods",
  receivedGoods: "receivedGoods",
};

///
export const templatesTabs = ["emailTemplates", "documentsTemplates"];
export const templatesTypes = {
  emailTemplates: "emailTemplates",
  documentsTemplates: "documentsTemplates",
};

///
export const toggleTimeTracking = [
  {
    name: Vocabulary.takePredefinedCost,
    value: "takePredefinedCost",
  },
  {
    name: Vocabulary.timeTracking,
    value: "timeTracking",
  },
];

///
export const additionalInformationForVariants = {
  price: "price",
  inventory_quantity: "inventory_quantity",
};

///
export const TemplatesTypeArray = ["estimate", "invoice", "gdpr"];

export const TemplatesType = {
  estimate: "estimate",
  invoice: "invoice",
  gdpr: "gdpr",
};

export const StatusesEnum = {
  gdpr: "GDPR",
};

export const OrderTypes = {
  ESTIMATE: "ESTIMATE",
  ORDER: "ORDER",
};

///
export const StockTransferStatuses = {
  inProgress: "In progress",
  inTransit: "In transit",
  received: "Received",
  canceled: "Canceled",
  outtake: "Outtake",
};

export const StockTransferStatusesAutocomplete = [
  "In progress",
  "In transit",
  "Received",
  "Canceled",
  "Outtake",
];

export const StockTransferStatusesAutocompleteWithoutOuttake = [
  "In progress",
  "In transit",
  "Received",
  "Canceled",
];

///
export const PurchaseOrderStatuses = {
  open: "Open",
  closed: "Closed",
};

/**
 *
 */
export const ShowGoodsType = {
  purchaseOrder: "purchaseOrder",
  inventory: "inventory",
  product: "product",
};

/**
 *
 */
export const locationName = "upVolt GmbH";

/**
 *
 */
export const shipmentStatuses = {
  pending: "pending",
  inTransit: "inTransit",
  delivered: "delivered",
  inbound: "inbound",
  outbound: "outbound",
};

export const checkInSteps = [
  "device",
  "partnerTechnician",
  "customer",
  "workflow",
  "additionalInformation",
  "issueDescription",
];

export const productTypes = {
  material: "Material",
  totalDevice: "Total device",
  excess: "Excess",
  product: "Product",
  service: "Service",
  bundle: "Bundle",
  transport: "Transport",
  replacement: "Replacement",
  other: "Other",
  module: "Module",
};

export const productTypesArray = [
  "Material",
  "Total device",
  "Excess",
  "Product",
  "Service",
  "Bundle",
  "Transport",
  "Replacement",
  "Other",
  "Module",
];

/**
 *
 */
export const settingsMenu = [
  {
    name: Vocabulary.taxRates,
    path: `${localUrlEnum.settings}?menu=taxRates`,
  },
  {
    name: Vocabulary.emailSettings,
    path: `${localUrlEnum.settings}?menu=emailSettings`,
  },
  {
    name: Vocabulary.mainUser,
    path: `${localUrlEnum.settings}?menu=mainUser`,
  },
  {
    name: Vocabulary.anaf,
    path: `${localUrlEnum.settings}?menu=anaf`,
  },
  {
    name: Vocabulary.integrations,
    path: `${localUrlEnum.settings}?menu=integrations`,
  },
  {
    name: Vocabulary.priorityColors,
    path: `${localUrlEnum.settings}?menu=priorityColors`,
  },
];

/**
 *
 */
export const settingsMenuEnum = {
  taxRates: "taxRates",
  emailSettings: "emailSettings",
  mainUser: "mainUser",
  anaf: "anaf",
  integrations: "integrations",
  priorityColors: "priorityColors",
};

export const productSettings = {
  attributes: "attributes",
  categories: "categories",
  types: "types",
};

export const otherReports = {
  devicesReports: "devices",
  productsReports: "products",
  technicianEfficiency: "users",
};

export const ordersType = {
  orders: "orders",
  trashedOrders: "trashedOrders",
};

export const modelTypesForAlerts = {
  products: "products",
  orders: "orders",
};
